<div class="range-buttons-wrapper">
  <div class="range-button" (click)="selectLastDays(0)">Today</div>
  <div class="range-button" (click)="selectLastDays(1)">Yesterday</div>
  <div class="range-button" (click)="selectLastDays(7)">Last 7 days</div>
  <div class="range-button" (click)="selectLastDays(14)">Last 14 days</div>
  <div class="range-button" (click)="selectLastDays(21)">Last 21 days</div>
  <div class="range-button" (click)="selectLastMonth(1)">Last month</div>
  <div class="range-button" (click)="selectLastMonth(4)">Last quarter</div>
</div>
